// extracted by mini-css-extract-plugin
export var subtitle = "_aq-2";
export var title = "_aq-0";
export var titleNoWrap = "_aq-1";